import {
  GET_INSTITUTION,
  ADD_INSITITUTION,
  UPDATE_INSTITUTION,
  GET_INSTITUTION_BY_ID,
} from '../types'

const INITIAL_STATE = {
  allInsti: {},
  updateInsti: [],
  getoneInsti: [],
}

const institutionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_INSTITUTION:
      return {
        ...state,
        allInsti: payload.data[0],
        loader: false,
      }
    case ADD_INSITITUTION:
      return {
        ...state,
        addInsti: payload,
      }

    case UPDATE_INSTITUTION:
      return {
        ...state,
        updateInsti: payload.data,
        loader: false,
      }

    case GET_INSTITUTION_BY_ID:
      return {
        ...state,
        getoneInsti: payload.data,
      }

    default:
      return state
  }
}

export default institutionReducer
